import { UpdateTemplate, useCreateTemplateMutation, useUpdateTemplateMutation } from '@/services/gql/graphql.generated';
import { useCallback } from 'react';

export const useCreateTemplateFromUpdateTemplate = () => {
  const [{ error }, update] = useUpdateTemplateMutation();
  const [responseData, create] = useCreateTemplateMutation();

  const createTemplate = useCallback(
    async (requestedTemplate: UpdateTemplate) => {
      const result = await create({
        locationId: requestedTemplate.locationId,
        name: requestedTemplate.name
      });

      const newTemplate = result.data?.createTemplate;

      if (!newTemplate) {
        throw Error('Template create failed!');
      }

      const populateTemplate = await update({
        updateTemplate: {
          ...requestedTemplate,
          id: newTemplate.id
        }
      });

      return populateTemplate;
    },
    [create]
  );

  return { createTemplate, error, fetching: responseData.fetching };
};
